import { Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/src/components/constants';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import './no-lessons-pane.scss';

interface NoLessonsPaneProps extends WrappedComponentProps {
    descriptionId?: string;
    titleId: string;
}

export const NoLessonsPane = ({ titleId }: NoLessonsPaneProps) => {
    return (
        <div className="no-lessons-pane">
            <div className="no-lessons-pane__content">
                <div className="no-lessons-pane__title">
                    <Text id={titleId} size={Text.SIZE.XL} type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </div>
            </div>
        </div>
    );
};

export default injectIntl(NoLessonsPane);
